import { render } from "./deliveryEdit.vue?vue&type=template&id=ef308b46&scoped=true"
import script from "./deliveryEdit.vue?vue&type=script&lang=js"
export * from "./deliveryEdit.vue?vue&type=script&lang=js"

import "./deliveryEdit.vue?vue&type=style&index=0&id=ef308b46&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef308b46"]])

export default __exports__